// app/learn/workspace.tsx
// The old WorkspaceScreen was a developer/admin tool and is not part of the user journey.
// Redirect to the real onboarding entry point.
import { Redirect } from 'expo-router';

export default function LearnWorkspaceRedirect() {
  return <Redirect href="/learn/path/create" />;
}
